
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="pt-40 pb-28 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block px-4 py-2 bg-amber-500/10 border border-amber-500/30 mb-8">
            <span className="text-amber-400 text-sm font-medium tracking-widest" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              COMPREHENSIVE BUSINESS SUPPORT
            </span>
          </div>

          <h2 className="text-5xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            インターネットを活用した<br />
            総合ビジネスサポート
          </h2>

          <div className="flex items-center justify-center gap-3 mb-10">
            <div className="w-16 h-0.5 bg-amber-500"></div>
            <div className="w-2 h-2 bg-amber-500 rotate-45"></div>
            <div className="w-16 h-0.5 bg-amber-500"></div>
          </div>

          <p className="text-lg text-gray-300 mb-14 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            株式会社etaは、インターネットを利用した情報提供サービス、<br />
            各種事務処理の代行業務、ウェブサイト・クラウドシステムの企画・運営、<br />
            経営・業務コンサルティング、デジタルコンテンツの企画・制作・販売を行っています。
          </p>

          <div className="flex items-center justify-center gap-6">
            <button 
              onClick={() => scrollToSection('services')}
              className="px-10 py-4 bg-amber-500 text-slate-900 font-bold hover:bg-amber-400 transition-all duration-300 whitespace-nowrap shadow-xl hover:shadow-amber-500/50 hover:scale-105"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              事業内容を見る
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-10 py-4 bg-transparent text-amber-400 font-bold border-2 border-amber-500 hover:bg-amber-500/10 transition-all duration-300 whitespace-nowrap hover:scale-105"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              お問い合わせ
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
